
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Intermediate Algebra 1e */ '02776133-d49d-49cb-bfaa-67c7f61b25a1': [
    /* Intermediate Algebra 2e */ ['4664c267-cd62-4a99-8b28-1cb9b3aee347', {
      /* Preface to the same module in 2e */
      '301d5176-9ace-4219-b44b-85dcf781e1e3' : '8299e5c9-9342-4802-96c4-5c9cc0b69482',
      /* 1.0  Introduction	to the same module in 2e */
      '1c2686fd-6e5c-417e-8340-38c9eb5e1019' : '9d76d944-ac49-4b1b-aba6-48ef233ff242',
      /* 1.1  Use the Language of Algebra	to the same module in 2e */
      'd3697553-3900-453f-8c08-8f74d55711ba' : '772b200d-b3d4-4654-bc37-a1d3fb70efd7',
      /* 1.2  Integers	to the same module in 2e */
      '05eab039-6d1c-4d80-8c8c-94469164a52c' : '59ccdc10-4ea2-46d9-b94c-10312203255e',
      /* 1.3  Fractions	to the same module in 2e */
      '425620d9-51dd-45e5-8a21-953998a4a77f' : '354e36b5-5c37-49c5-b887-f6541cbd4a0c',
      /* 1.4  Decimals and Real Numbers	to the same module in 2e */
      '99b2296a-9957-4380-aff4-248abadc862b' : 'a140725d-a6e3-4705-8430-b4f350efb27f',
      /* 1.5  Properties of Real Numbers	to the same module in 2e */
      '987da0d0-2366-47d6-aa25-904e24991866' : 'a5d6ef58-bf53-4cb4-828e-fe9409d7f075',
      /* 2.0 Introduction	to the same module in 2e */
      '85b55407-c981-455f-9c47-d72340bd1dbb' : 'af35fc2f-d1ab-4ee5-acb5-ed9f830f2368',
      /* 2.1  Use a General Strategy to Solve Linear Equations	to the same module in 2e */
      '9f100e8f-6d15-4cae-bc22-c306e9d7d55c' : '7dd75394-ab7a-48ba-af4a-a3c92a23e31f',
      /* 2.2  Use a Problem-Solving Strategy	to the same module in 2e */
      '37489cba-b108-41fd-88b1-ab568fcea766' : 'e364a309-6424-4a61-b278-fb415bc56bea',
      /* 2.3  Solve a Formula for a Specific Variable	to the same module in 2e */
      'b03538a1-8a7b-4158-a68b-e0e8a24c9fd4' : '93da06b2-130b-4db5-943f-ea450b018ec8',
      /* 2.4  Solve Mixture and Uniform Motion Applications	to the same module in 2e */
      '36adea73-2201-46d3-b9b6-d13ef7df78b2' : '03cd7e0b-bb44-48fe-907b-6018225174d7',
      /* 2.5  Solve Linear Inequalities	to the same module in 2e */
      '27141d73-3006-49fa-98eb-5744b312aea7' : 'c929c760-07fb-4c52-9491-51030f328e71',
      /* 2.6  Solve Compound Inequalities	to the same module in 2e */
      '730fb57f-9832-4993-a96f-39ecb47c371d' : '74bac4a5-36c7-4127-8dfd-887d07b93078',
      /* 2.7  Absolute Value Inequalities	to the same module in 2e */
      '6cfd2376-f945-4ebb-bdb6-92ac7398c9ad' : 'cd18321e-2b55-4a86-b6bb-20c998135a50',
      /* 3.0 Introduction	to the same module in 2e */
      '4d690921-1182-4ad3-86e0-7f849efbd233' : 'aa4399b8-4e63-4440-8508-0df730dd484a',
      /* 3.1  Graph  Linear Equations in Two Variables	to the same module in 2e */
      '26e8f94c-1f76-46ec-8e6c-344f06971cf5' : '9d3bc1f0-6330-4e24-b67a-6f07f074d79c',
      /* 3.2  Slope of a Line	to the same module in 2e */
      'c7953cb6-51e3-48e7-9969-821f34daec42' : 'f54f6801-0920-459c-af2e-72f85ddda846',
      /* 3.3  Find the Equation of a Line	to the same module in 2e */
      'a70487c0-0cc1-4b9b-bed5-8c15bf231b19' : 'b7d62225-c09f-478e-8c1d-df46042de0b0',
      /* 3.4  Graph Linear Inequalities	to the same module in 2e */
      'f15d09b6-aae4-4ad3-a9e6-c9d1ac2436e3' : 'eccd2fd2-0d20-4486-a61a-9ec728c76cf1',
      /* 3.5  Relations and Functions	to the same module in 2e */
      '5e548626-8f0f-496d-ab87-4f0358ca2fd3' : '59fe6dc4-6e09-4a88-aa1c-b5f72bd79a20',
      /* 3.6  Graphs of Functions	to the same module in 2e */
      'da9d6ce0-a078-4ca2-97af-8cb374f040f5' : '4b2bbf1b-2df7-4b9a-9933-dd70d1fd8ada',
      /* 4.0 Introduction	to the same module in 2e */
      'f7768096-00ec-46cd-8e16-719f51b13663' : 'f94eaf18-fae0-4122-9c5d-294cb1994d02',
      /* 4.1  Solve Systems of Equations with Two Variables	to the same module in 2e */
      'a236420d-b79a-43e3-8f7c-1b8e18c5045e' : 'b9f8475e-9490-4f24-995f-2923b1ed9644',
      /* 4.2  Solve Applications with Systems of Equations	to the same module in 2e */
      '560ed071-7c89-41ad-8282-94b385324dd9' : '6c760b6e-5e4f-4a82-a738-af62b1b2b52a',
      /* 4.3  Solve Mixture Applications with Systems of Equations	to the same module in 2e */
      '4cdf0dd0-1221-47ea-9e33-0562d98f6eec' : '67b64586-4ca7-4592-806a-141e8a451c70',
      /* 4.4  Solve Systems of Equations with Three Variables	to the same module in 2e */
      '56fc492e-b71a-4a4a-bab4-b95331687fd3' : '6a681928-6850-4e59-a054-1bf35c38b627',
      /* 4.5  Solve Systems of Equations Using Matrices	to the same module in 2e */
      '6a4b38a5-e5d8-4f37-ac52-172097013b24' : '2f299a81-c08f-4445-a007-7f84b7ad19bd',
      /* 4.6  Determinants	to the same module in 2e */
      '0ab06d7a-f85b-4c4d-b56b-aa826ea612a4' : '7426d422-4f55-40d9-9fe3-0d78b5f05709',
      /* 4.7  Graphing Systems of Linear Inequalities	to the same module in 2e */
      'ccd859e9-a2f9-4004-abe9-5823a43ab70f' : '8b5bc559-9db7-47d7-a180-08b50f0a248f',
      /* 5.0 Introduction	to the same module in 2e */
      'e4ee6662-5fe2-4051-910b-571d5c1e064c' : 'a956c919-926c-4aef-9543-6e303c751f25',
      /* 5.1  Add and Subtract Polynomials	to the same module in 2e */
      '9e9d60d5-b373-4675-a019-2b4220bd93f4' : 'c82f19a0-7d76-445d-a89f-9c230a8337f5',
      /* 5.2  Properties of Exponents and Scientific Notation	to the same module in 2e */
      '3fa6a6c5-9a36-4dee-aea1-0166229f52fb' : '8a394961-3438-41bc-9e46-9d21493bf274',
      /* 5.3  Multiply Polynomials	to the same module in 2e */
      '0b9be1db-21c4-4bd0-8f8e-d809f6ff7c8c' : '44bb078c-7062-4d79-9ed7-05adbaf88b08',
      /* 5.4  Dividing Polynomials	to the same module in 2e */
      '4102cdd7-8da4-4802-83c7-342d2f3cd3f5' : '79197e6f-72b5-42b1-9699-5dc1d66a0bfd',
      /* 6.0 Introduction	to the same module in 2e */
      'e7bd9d46-620e-421c-a831-59362756e121' : '1de9bc09-87aa-4173-863e-38e91261e69b',
      /* 6.1  Greatest Common Factor and Factor by Grouping	to the same module in 2e */
      'b380a9f9-f0f7-4fdf-9a79-5646a9f745f9' : 'bad7d0d2-4abc-4fd5-922c-4e920bc0ae2c',
      /* 6.2  Factor Trinomials of the Form	to the same module in 2e */
      'edd9c403-9825-4cf2-b237-2e05552ea3ec' : '9c041b42-1044-48c8-b300-81299735debf',
      /* 6.3  Factor Special Product	to the same module in 2e */
      'd844a3e4-0163-4936-91ca-a71142f07358' : 'd7aa777f-a37f-429f-b911-48ed2cdca05e',
      /* 6.4  General Strategy for Factoring	to the same module in 2e */
      '93db7208-2f30-47df-91eb-33984d9fb8b7' : '2cc3ff3f-bafc-4dc2-a890-59178cbf5f34',
      /* 6.5  Polynomial Equations	to the same module in 2e */
      'da8478b4-93bc-4919-81a1-5e3267050e7e' : '8e386304-d5ea-4328-8d74-7496f3969409',
      /* 7.0 Introduction	to the same module in 2e */
      'bec06c57-fda4-4085-9b2e-001608ae1e9a' : '7bd90579-9bef-472e-955b-26dbd793daed',
      /* 7.1  Multiply and Divide Rational Expression	to the same module in 2e */
      'c392efcb-8505-423b-9356-890700515e3b' : '4fc7ab19-c7ec-482f-a0c5-e54f61f107cf',
      /* 7.2  Add and Subtract Rational Expression	to the same module in 2e */
      '6c5aa31f-890a-445a-9a9c-44a7941355f7' : 'd421a741-8a81-4ada-972f-808935ae1579',
      /* 7.3  Simplify Complex Rational Expressions	to the same module in 2e */
      '9c6e36cd-6eb0-4457-8db5-0da97afca2ac' : '85bdd3a5-e04f-446c-879e-a5e932ea3623',
      /* 7.4  Solve Rational Equations	to the same module in 2e */
      '114b6c20-ac2e-4d26-8ede-f6f4a0bce191' : '6045e284-ab6f-4def-b9df-d288b58e0be9',
      /* 7.5  Solve Applications with Rational Expressions	to the same module in 2e */
      'b694470e-ede5-454b-8052-34b9bc92ae11' : 'cde4ccc5-d525-4797-9dca-169240adf0c7',
      /* 7.6  Solve Rational Inequalities	to the same module in 2e */
      'a68b06f6-2833-4512-b24f-c0da889a8759' : '74088145-486c-473d-a07e-3dbb3fe2c6d2',
      /* 8.0 Introduction	to the same module in 2e */
      'ebaad2c9-692c-4873-a610-037583b5a575' : '78a9f055-3962-413c-a010-f6937d8f9e08',
      /* 8.1  Simplify Expressions with Roots	to the same module in 2e */
      'eb8b8413-de16-4b16-8555-f29918cf1207' : 'c93e90e4-5eb7-4422-9e72-263f86208f5f',
      /* 8.2  Simplify Radical Expressions	to the same module in 2e */
      'dbb319b9-f421-4570-9953-ca5a39b933dc' : '41eef600-202f-4bd3-b23f-9607a02bca79',
      /* 8.3  Simplify Rational Exponents	to the same module in 2e */
      'eb676a52-0094-4ffb-95d3-c8eb0596e397' : '5f8936f5-a82d-4f0d-ba8d-8341d1f58083',
      /* 8.4  Add , Subtract, and Multiply Radical Expressions	to the same module in 2e */
      'a38378e8-cc28-44f4-8c29-789cc2550c6a' : '18c43895-0fa9-429e-9f37-bd4e6359b579',
      /* 8.5  Divide Radical Expressions	to the same module in 2e */
      '94bbb796-17c2-4a4d-a202-8ead79bc0700' : '216b2ead-1007-4909-9a05-26e7f96ad159',
      /* 8.6  Solve Radical Equations	to the same module in 2e */
      'd5923faf-e056-4b0a-b96d-ee6429d48e36' : '9bbc1d42-1636-418b-871a-669d3db32c75',
      /* 8.7  Use Radicals in Functions	to the same module in 2e */
      'd5887b1b-5ca2-40b7-99c3-43f38b1a5425' : 'cf2a4a73-4f8d-4736-bd51-3a1ba306981d',
      /* 8.8  Use the Complex Number System	to the same module in 2e */
      '916a2094-3b51-4f1a-803d-95909a359123' : '7666656b-7531-4995-a8fd-0e6535eba35d',
      /* 9.0 Introduction	to the same module in 2e */
      '6bdff6e4-f801-42fd-9e84-885e7a8940f4' : '5f5fbc58-7c27-4c21-976b-c4849754f484',
      /* 9.1  Solve Quadratic Equations Using the Square Root Property	to the same module in 2e */
      'b9659e42-3afa-4449-81d9-a017c35de140' : '3707d74c-647c-4ce7-ab14-81863dee535c',
      /* 9.2  Solve Quadratic Equations by Completing the Square	to the same module in 2e */
      '3e7f365d-4885-4b7a-bb2a-4358cbc00d2e' : '57db40dc-810a-4ceb-bdb6-ba03274e9da9',
      /* 9.3  Solve Quadratic Equations Using the Quadratic Formula	to the same module in 2e */
      'f045a37e-bf7c-4818-95a1-e29172da48b4' : '5bc3569f-5f65-4f5e-8249-e37e01d20dce',
      /* 9.4  Solve Quadratic Equations in Quadratic Form	to the same module in 2e */
      '48820a47-b89e-428f-9534-a71207245a16' : '37b7878c-e2b6-4e52-9854-e2c845477271',
      /* 9.5  Solve Applications of Quadratic Equations	to the same module in 2e */
      'b6bba63f-4f97-49ab-ac8a-01c3927118a7' : '99e5b365-1031-4792-a49a-80e7e69855eb',
      /* 9.6  Graph Quadratic Functions Using Properties	to the same module in 2e */
      '3de1ae34-6225-4751-be75-a17b3e0e665b' : '05dd84c8-48f9-4017-b0e9-85a9275b5686',
      /* 9.7  Graph Quadratic Functions Using Transformations	to the same module in 2e */
      '9054900c-f191-40ed-8ceb-e4f051bbbf2b' : '85761b0e-ad1e-49f7-9e8c-5838489c57bc',
      /* 9.8 Solve Quadratic Inequalities	to the same module in 2e */
      '4f54d544-fb3e-4336-9f8c-57e6b8489257' : 'ae97f647-7a2d-46f4-b9bf-c1205b91420b',
      /* 10.0 Introduction	to the same module in 2e */
      '56191a29-2081-4897-a226-a3524557a6cd' : '337fc98c-2c5c-4561-8541-3a3d428c430c',
      /* 10.1  Finding Composite and Inverse Functions	to the same module in 2e */
      'e961e848-a920-4620-9a73-94a4e40d17d7' : 'b3e6b118-b5ba-4f39-bd37-38c1a6812712',
      /* 10.2  Evaluate and Graph Exponential Functions	to the same module in 2e */
      'ada4680b-1494-4703-b7e1-f4eed6c6f2f1' : '054d3ec3-bee3-40e5-9e9b-44d6b973844b',
      /* 10.3  Evaluate and Graph Logarithmic Functions	to the same module in 2e */
      'c44f0fc4-b7ab-43bc-9b51-100c8795dc0d' : 'afd63274-5172-405b-b787-bfd578b98d44',
      /* 10.4  Use the Properties of Logarithms	to the same module in 2e */
      'b46ba70b-29a0-4dc8-9e4e-0174621fb1bd' : 'e4102aea-5331-4ca6-a1ca-4d9316e6d955',
      /* 10.5  Solve Exponential and Logarithmic Equations	to the same module in 2e */
      '546cf0af-8548-42e9-a94f-d6e274224004' : '5058068c-0746-4f7d-b995-311859e1010e',
      /* 11.0 Introduction	to the same module in 2e */
      'b73509bd-321c-4518-ab57-6d09374aa418' : 'ce066327-babd-49b8-818b-03c4bc6ed6ce',
      /* 11.1  Use the Distance and Midpoint Formula; Use the Properties of Circles	to the same module in 2e */
      '30062189-1923-4bf7-902b-9f2691a64c71' : '481bcd2d-93f7-480e-a6bd-1c71ae29a17f',
      /* 11.2  Use the Properties of Parabolas	to the same module in 2e */
      '789eaa88-3770-4bb0-9039-ff1146680681' : '8cbefbee-ca94-4a30-a70e-86f931e36b3b',
      /* 11.3  Use the Properties of Ellipses	to the same module in 2e */
      '4c350ea6-1dd0-4a11-a80a-9a5f02497a87' : '866308ab-9879-4066-9f70-16837ed7ec37',
      /* 11.4  Use the Properties of Hyperbolas	to the same module in 2e */
      '5784f55d-62cb-474f-aa4f-747760be4966' : 'c2cd37d4-1a2c-4738-8134-f5accdd72c0f',
      /* 11.5  Solve Systems of Nonlinear Equations	to the same module in 2e */
      'c2649a40-6525-4e7f-a3b4-31f5d8a52d29' : 'cd76dfa3-cea1-4f11-8940-da0fcaa4237c',
      /* 12.0 Introduction	to the same module in 2e */
      '75bef0cf-33a1-4723-9669-73473278f1ce' : '050b2640-ca09-46c5-8669-131098661a37',
      /* 12.1  Sequences	to the same module in 2e */
      '81cfc493-c857-49bd-a23f-82ac67cbb9c4' : 'c3d78cf5-7d1d-437f-81b5-2172ad676053',
      /* 12.2  Arithmetic Sequences	to the same module in 2e */
      'beab9aa5-3e76-4e7b-92f5-1eae134e874b' : '3519191c-a907-44ab-9906-f2ee4269a507',
      /* 12.3  Geometric Sequences and Series	to the same module in 2e */
      '7e49f09d-5033-4393-a74f-556d343328c7' : '2f5b3bc9-ccfe-42a1-b18e-7aab5baf9079',
      /* 12.4  Binomial Theorem	to the same module in 2e */
      'c9aabcfa-7dac-4cdb-bca0-f8738ce61f22' : '85d5a058-3b5d-4518-9473-7c8cb29e1b2b',
    }],
  ],
} as CanonicalBookMap;
